module.exports = __webpack_public_path__ + "img/zoz2-logo.ca79181a.png";